<template>
</template>

<script>
  import utils from '../common/js/util'
  import cook from '../common/js/cook'

  export default {
    name: "JwtLogin",
    mounted() {
      console.log(this.$route.query.token);
      this.$http({
        method: "GET",
        url: '/rest/sysUser/sysUserLogin',
        params: {
          token: this.$route.query.token,
        }
      }).then(res => {
        console.log("进入123213")
        this.$http({
          method: "post",
          url: '/rest/auth/login',
          headers: {'Content-type': 'application/x-authc-username-password+json'},
          data: {
            user: String(res.data.sysUser.account),
            password: String(res.data.sysUser.password)
          }
        }).then(res2 => {
          //获取登录人webid44的权限 给qhr页面权限使用
          res.data.webAuthLst.forEach((item) => {
            if (item.webId==44) {
               sessionStorage.setItem("webId_44Auth",String(item.auth))
            }
          })
          sessionStorage.setItem("account", String(res.data.sysUser.account));
          sessionStorage.setItem("sysUserId", String(res.data.sysUser.id));
          sessionStorage.setItem("empPk", String(res.data.sysUser.empPk));

          sessionStorage.setItem("user", String(res.data.sysUser.account));
          sessionStorage.setItem('nickname', String(res.data.sysUser.nickName));
          sessionStorage.setItem("passwords", String(res.data.sysUser.password));

          cook.setCookie('user', String(res.data.sysUser.account), 7200);
          console.log('getCookie' + cook.getCookie('user'))
          //成功后自动跳转到第一个有权限的页面，缺点是顺序被后台控制
          let webIdArr = []
          let pathArr = [];
          let data = res.data
          let routes = this.$router.options.routes
          data.webAuthLst.map(item => {
            webIdArr.push(item.webId)
          })
          routes.map(item => {
            item.children.map(item2 => {
              if (webIdArr.indexOf(item2.webId) > -1) {
                pathArr.push(item2.path)
              }
            })
          })
          //这里其实可以优化，不等map结束，就可以跳转了，但也就几毫秒，无所谓
          if (pathArr.length > 0) {
            this.$router.push({path: pathArr[0]});
          } else {
            this.$router.push({path: '/noPermission'});
          }
        })
      }).catch((err) => {
        utils.myNotify(this, 'error', err.response, '获取用户权限信息失败，请稍后重试')
      })
    },
    methods: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/JwtLogin.vue